/* Green Transition consumer-rights layer (S.I. No. 124/2026). Markup + rules: snippets/gt-consumer-rights.liquid.
   1. [data-gt-open="legal-guarantee"]  opens the official EU legal guarantee notice on the first click.
   2. [data-gt-open="garan"]            opens the full EU GARAN durability label (nested display -> full label).
   The official SVG files are never altered on disk. For the GARAN label only the three fields the
   Implementing Regulation (EU) 2025/1960 marks as editable are filled in at display time: XX (years),
   Brand/Trademark, Model identifier. The artwork is mounted in a shadow root so its generic class
   names (.cls-1 ...) cannot clash with the page or with each other. */
(function () {
  'use strict';
  var d = document, w = window;
  if (w.gtConsumerRights) return;
  w.gtConsumerRights = true;
  var GARAN_INFO = 'https://europa.eu/youreurope/commercial-guarantee-durability/index.htm';

  function openDialog(dlg, opener) {
    if (!dlg) return false;
    dlg.querySelectorAll('img[data-gt-src]').forEach(function (img) { img.src = img.getAttribute('data-gt-src'); img.removeAttribute('data-gt-src'); });
    if (typeof dlg.showModal !== 'function') return false; /* no <dialog> support: the trigger's own link is followed */
    dlg.gtOpener = opener || null;
    if (!dlg.open) dlg.showModal();
    return true;
  }

  /* ---- EU GARAN label ---- */
  var svgCache = {};
  function loadSvg(url) {
    return svgCache[url] || (svgCache[url] = fetch(url).then(function (r) { if (!r.ok) throw new Error('svg ' + r.status); return r.text(); })
      .catch(function (e) { delete svgCache[url]; throw e; })); /* a failed request must not be cached: the next click retries */
  }
  function ensureInter() { /* the Regulation fixes the label font: Inter (Regular, SemiBold, ExtraBold) */
    if (d.getElementById('gt-inter')) return;
    var l = d.createElement('link'); l.id = 'gt-inter'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap'; d.head.appendChild(l);
  }
  function setText(node, value) { /* keep the first tspan (position + style), drop kerning fragments */
    var spans = node.querySelectorAll('tspan');
    if (!spans.length) { node.textContent = value; return; }
    spans[0].textContent = value;
    for (var i = spans.length - 1; i > 0; i--) spans[i].parentNode.removeChild(spans[i]);
  }
  function mountLabel(host) {
    if (host.gtMounted || host.shadowRoot) return; host.gtMounted = true;
    var data = host.dataset; ensureInter();
    loadSvg(data.gtSvg).then(function (txt) {
      var root = host.attachShadow({ mode: 'open' });
      root.innerHTML = '<style>:host{display:block}svg{display:block;width:100%;height:auto}</style>' + txt.replace(/<\?xml[^>]*\?>/, '');
      var svg = root.querySelector('svg'); if (!svg) return;
      svg.setAttribute('role', 'img'); svg.setAttribute('aria-label', data.gtLabel || '');
      var brand = null, model = null;
      svg.querySelectorAll('text').forEach(function (t) {
        var c = t.textContent.replace(/\s+/g, ' ').trim();
        if (c === 'XX') setText(t, data.gtYears);
        else if (/^Brand/i.test(c)) brand = t;
        else if (/^Model/i.test(c)) model = t;
      });
      if (brand) setText(brand, data.gtBrand || '');
      if (model) {
        setText(model, data.gtModel || '');
        /* the template's "Model identifier" ends at the right margin, which mirrors the left margin of
           "Brand/Trademark". Anchor real identifiers to that same margin so long ones grow to the left. */
        var tx = function (t) { var m = /translate\(\s*([\d.]+)/.exec(t.getAttribute('transform') || ''); return m ? parseFloat(m[1]) : 0; };
        var vb = svg.viewBox && svg.viewBox.baseVal ? svg.viewBox.baseVal.width : 0;
        if (brand && vb) { var span = model.querySelector('tspan') || model; span.setAttribute('x', (vb - tx(brand) - tx(model)).toFixed(2)); span.setAttribute('text-anchor', 'end'); }
      }
    }).catch(function () { host.gtMounted = false; var btn = host.closest && host.closest('.gt-garan__btn'); if (btn) btn.hidden = true; /* never leave an empty control in the tab order; the caption still carries the facts */ });
  }
  function mountAll(scope) { (scope || d).querySelectorAll('[data-gt-svg]').forEach(mountLabel); }

  function link(href, text, attrs) { var a = d.createElement('a'); a.href = href; a.textContent = text;
    if (attrs !== false) { a.target = '_blank'; a.rel = 'noopener'; var sr = d.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = ' (opens in a new tab)'; a.appendChild(sr); }
    return a; }
  function fillGaranDialog(trigger) {
    var body = d.querySelector('[data-gt-garan-body]'); if (!body) return;
    var owner = trigger.closest && trigger.closest('.gt-garan'); /* the info button and "Learn more" carry no data of their own */
    if (owner && owner.querySelector('.gt-garan__btn')) trigger = owner.querySelector('.gt-garan__btn');
    var s = trigger.dataset; body.textContent = '';
    if (s.gtFile && /^(https?:)?\/\//.test(s.gtFile)) { var img = d.createElement('img'); img.className = 'gt-garan__file'; img.src = s.gtFile; img.alt = s.gtLabel || ''; body.appendChild(img); }
    else { var host = d.createElement('div'); host.className = 'gt-garan__full'; host.setAttribute('data-gt-svg', s.gtFull);
      ['gtYears', 'gtBrand', 'gtModel', 'gtLabel'].forEach(function (k) { host.dataset[k] = s[k] || ''; }); body.appendChild(host); mountLabel(host); }
    var about = d.createElement('p'); about.className = 'gt-garan__about';
    about.textContent = 'This EU label shows a guarantee of durability that the producer gives for this product: at no extra cost, covering the whole product, for more than two years. It applies in addition to your legal guarantee.';
    body.appendChild(about);
    var p = d.createElement('p'); p.className = 'gt-notice__links';
    p.appendChild(link(GARAN_INFO, 'About the EU GARAN label'));
    if (s.gtTerms && /^(https?:)?\/\//.test(s.gtTerms)) p.appendChild(link(s.gtTerms, 'Manufacturer warranty terms'));
    var lg = link('#', 'Your legal guarantee rights', false); lg.setAttribute('data-gt-open', 'legal-guarantee'); p.appendChild(lg);
    body.appendChild(p);
  }

  function handleOpen(open, e) {
    var garan = open.getAttribute('data-gt-open') === 'garan';
    if (garan) fillGaranDialog(open);
    else { var other = d.getElementById('gt-garan-dialog'); if (other && other.open) other.close(); }
    if (openDialog(d.getElementById(garan ? 'gt-garan-dialog' : 'gt-legal-guarantee'), open)) e.preventDefault();
    else if (garan) { e.preventDefault(); w.open(GARAN_INFO, '_blank', 'noopener'); } /* no <dialog>: the button has no link of its own */
  }

  /* Clicks INSIDE an open dialog are handled at window level in the CAPTURE phase and stopped there.
     The theme closes the cart drawer and its modals from capture-phase "click outside" listeners on the
     root element; our dialogs sit outside those components, so without this every click in the notice
     (Close, the text version, a link) also closed the drawer behind it. Default actions still happen. */
  w.addEventListener('click', function (e) {
    var el = e.target; if (!el || !el.closest) return;
    var dlg = el.closest('.gt-dialog'); if (!dlg) return;
    e.stopPropagation();
    var open = el.closest('[data-gt-open]'); if (open) { handleOpen(open, e); return; }
    if (el.closest('[data-gt-close]')) { dlg.close(); return; }
    if (el === dlg) { /* click on the backdrop */
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    }
  }, true);

  /* triggers anywhere else on the page */
  d.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return; /* open-in-new-tab and friends keep working */
    if (e.defaultPrevented) return; /* the PDP tab opener (wireOpenTab) already handled this click: the notice is only the fallback */
    var el = e.target; if (!el || !el.closest || el.closest('.gt-dialog')) return;
    var open = el.closest('[data-gt-open]'); if (open) handleOpen(open, e);
  });

  /* Escape closes the dialog on keydown; swallow the matching keyup so the theme's own Escape handler
     does not also close the cart drawer or quick view the notice was opened from. */
  d.addEventListener('cancel', function (e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('gt-dialog')) return;
    var once = function (k) { if (k.key === 'Escape' || k.key === 'Esc') k.stopPropagation(); w.removeEventListener('keyup', once, true); };
    w.addEventListener('keyup', once, true);
  }, true);
  d.addEventListener('close', function (e) { var o = e.target && e.target.gtOpener; if (o && o.focus && d.contains(o)) o.focus(); }, true);

  /* GARAN hosts arrive later too: the buy box is re-rendered on variant change and cloned into quick view */
  var queued = false;
  function queueMount() { if (queued) return; queued = true; (w.requestAnimationFrame || setTimeout)(function () { queued = false; markTriggers(); mountAll(); }); }
  var canDialog = typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function';
  function markTriggers() { if (canDialog) d.querySelectorAll('a[data-gt-open]:not([aria-haspopup])').forEach(function (a) { a.setAttribute('aria-haspopup', 'dialog'); }); }
  function start() { markTriggers(); mountAll(); if (w.MutationObserver && d.body) new MutationObserver(function (muts) { for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { queueMount(); break; } }).observe(d.body, { childList: true, subtree: true }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  w.gtMountLabels = mountAll;
})();
